/** YYYY-MM-DD yoki ISO — bugundan qancha kun qolgani (0 = bugun tugaydi, manfiy = muddati o'tgan) */
export function daysUntilExpiry(expiryDate: string | null | undefined): number | null {
  if (!expiryDate || typeof expiryDate !== 'string') return null;
  const m = expiryDate.trim().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(m)) return null;
  const end = new Date(`${m}T12:00:00`);
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  return Math.round((end.getTime() - now.getTime()) / 86400000);
}

export type ExpiryTone = 'none' | 'ok' | 'warn' | 'danger';

/** >15 kun yashil maydon, 15–3 sariq, <3 yoki muddati o'tgan qizil */
export function expiryTone(days: number | null): ExpiryTone {
  if (days === null) return 'none';
  if (days < 0) return 'danger';
  if (days < 3) return 'danger';
  if (days < 15) return 'warn';
  return 'ok';
}
